import React from "react";

/* SVG icons for each app card — matches approved mockup exactly.
   All icons: 20x20 viewBox, stroke-based, 1.5 stroke-width. */

const iconProps = {
  viewBox: "0 0 20 20",
  fill: "none",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  width: 20,
  height: 20,
};

export const AppIcon = ({ appId, style }) => {
  const Icon = icons[appId];
  if (!Icon) return null;
  return <Icon style={style} />;
};

const icons = {
  jobs: (props) => (
    <svg {...iconProps} style={props.style}>
      <rect x="3" y="3" width="14" height="14" rx="2" stroke="currentColor" />
      <path d="M3 8h14" stroke="currentColor" />
      <path d="M8 8v9" stroke="currentColor" />
    </svg>
  ),
  crm: (props) => (
    <svg {...iconProps} style={props.style}>
      <circle cx="10" cy="7" r="3" stroke="currentColor" />
      <path d="M4 17c0-3.3 2.7-6 6-6s6 2.7 6 6" stroke="currentColor" />
    </svg>
  ),
  ingest: (props) => (
    <svg {...iconProps} style={props.style}>
      <path d="M10 3v10" stroke="currentColor" />
      <path d="M6 9l4 4 4-4" stroke="currentColor" />
      <path d="M3 15v1a1 1 0 001 1h12a1 1 0 001-1v-1" stroke="currentColor" />
    </svg>
  ),
  sheets: (props) => (
    <svg {...iconProps} style={props.style}>
      <rect x="3" y="3" width="5.5" height="5.5" rx="1" stroke="currentColor" />
      <rect x="11.5" y="3" width="5.5" height="5.5" rx="1" stroke="currentColor" />
      <rect x="3" y="11.5" width="5.5" height="5.5" rx="1" stroke="currentColor" />
      <rect x="11.5" y="11.5" width="5.5" height="5.5" rx="1" stroke="currentColor" />
    </svg>
  ),
  autocycle: (props) => (
    <svg {...iconProps} style={props.style}>
      <path d="M10 3a7 7 0 11-7 7" stroke="currentColor" />
      <path d="M3 6V10H7" stroke="currentColor" />
      <circle cx="10" cy="10" r="2" stroke="currentColor" />
    </svg>
  ),
  website: (props) => (
    <svg {...iconProps} style={props.style}>
      <circle cx="10" cy="10" r="7" stroke="currentColor" />
      <path d="M3 10h14" stroke="currentColor" />
      <path d="M10 3a11 11 0 014 7 11 11 0 01-4 7 11 11 0 01-4-7 11 11 0 014-7z" stroke="currentColor" />
    </svg>
  ),
  financials: (props) => (
    <svg {...iconProps} style={props.style}>
      <circle cx="10" cy="10" r="7" stroke="currentColor" />
      <path d="M12.2 7.6c-.5-.7-1.3-1-2.2-1-1.3 0-2.3.7-2.3 1.7 0 2.4 4.8 1 4.8 3.4 0 1-1 1.7-2.5 1.7-1 0-1.9-.4-2.4-1.1" stroke="currentColor" />
      <path d="M10 5.2v9.6" stroke="currentColor" />
    </svg>
  ),
  resources: (props) => (
    <svg {...iconProps} style={props.style}>
      <path d="M4 4h12a1 1 0 011 1v10a1 1 0 01-1 1H4a1 1 0 01-1-1V5a1 1 0 011-1z" stroke="currentColor" />
      <path d="M7 4v12" stroke="currentColor" />
      <path d="M10 8h4" stroke="currentColor" />
      <path d="M10 11h4" stroke="currentColor" />
    </svg>
  ),
  traffic: (props) => (
    <svg {...iconProps} style={props.style}>
      <circle cx="5" cy="5" r="1.5" stroke="currentColor" />
      <circle cx="15" cy="5" r="1.5" stroke="currentColor" />
      <circle cx="5" cy="15" r="1.5" stroke="currentColor" />
      <circle cx="15" cy="15" r="1.5" stroke="currentColor" />
      <circle cx="10" cy="10" r="2" stroke="currentColor" />
      <path d="M6.5 6.5L8 8" stroke="currentColor" />
      <path d="M12 8l1.5-1.5" stroke="currentColor" />
      <path d="M6.5 13.5L8 12" stroke="currentColor" />
      <path d="M12 12l1.5 1.5" stroke="currentColor" />
    </svg>
  ),
  safeshare: (props) => (
    <svg {...iconProps} style={props.style}>
      <path d="M4 12l3 3 9-9" stroke="currentColor" />
      <rect x="3" y="3" width="14" height="14" rx="3" stroke="currentColor" />
    </svg>
  ),
};
